export default __webpack_public_path__ + "static/char-59-354e4ff62de2858ec83e52efe8c2a252.webp";